import apiClient from '../apiClient';
import { GET_SYSTEM_MARGIN_BY_ID_URL } from '../apiUrl';

const getSystemMarginByIdApi = Id => {
  return apiClient.get(GET_SYSTEM_MARGIN_BY_ID_URL(Id));
};

export default getSystemMarginByIdApi;
